export var ARROW_SIZE = 5;
export var MARGIN = ARROW_SIZE * 2 - 1; // Subtract 1 pixel for blending.